import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';

export default function FloorPlans({ onEnquireClick }) {
  return (
    <section
      id="floorplan"
      data-testid="floor-plan-section"
      className="py-10 sm:py-12 md:py-16 bg-[#F8F9FA] lg:mr-72 xl:mr-80"
    >
      <div className="max-w-5xl mx-auto px-4">
        {/* Floor Plans Grid */}
        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
          {/* Commercial Floor Plan */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="font-serif text-lg sm:text-xl text-[#9A7B4F] mb-2 text-center">
              Commercial Floor Plan
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-[#9A7B4F] mx-auto mb-4 sm:mb-6" />
            
            <div className="relative group">
              <img
                src="/media/commercial_floor_plan.webp"
                alt="Commercial Floor Plan"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Button
                  onClick={onEnquireClick}
                  className="bg-[#9A7B4F] hover:bg-[#8A6B3F] text-white rounded-none px-4 sm:px-6 py-3 sm:py-4 font-semibold text-xs sm:text-sm"
                >
                  ENQUIRE NOW
                </Button>
              </div>
            </div>
          </motion.div>

          {/* Typical Floor Plan */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <h3 className="font-serif text-lg sm:text-xl text-[#9A7B4F] mb-2 text-center">
              Typical Floor Plan
            </h3>
            <div className="w-10 sm:w-12 h-1 bg-[#9A7B4F] mx-auto mb-4 sm:mb-6" />
            
            <div className="relative group">
              <img
                src="/media/typical_floor_plan.webp"
                alt="Typical Floor Plan"
                className="w-full h-auto"
              />
              <div className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                <Button
                  onClick={onEnquireClick}
                  className="bg-[#9A7B4F] hover:bg-[#8A6B3F] text-white rounded-none px-4 sm:px-6 py-3 sm:py-4 font-semibold text-xs sm:text-sm"
                >
                  ENQUIRE NOW
                </Button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
